import React from "react";
import fixCategories from "../../../utils/fixCategories";
import { Context } from "../../context";
import { Link } from "gatsby";
const PostTerms = (props) => {
    const context = React.useContext(Context);
    const classNames = ((attributes) => {
        let className = ["wp-block-post-terms"];
        if (attributes.align === "full") {
            className.push("alignfull");
        }
        if (attributes.textAlign) {
            className.push("has-text-align-" + attributes.textAlign);
        }
        if (attributes.className) {
            className.push(attributes.className);
        }
        return className.join(" ");
    })(props.attributes);
    const archivePageUri = "/" + context.archivePage.slug + "/";
    if (!props.children?.length) {
        return React.createElement(React.Fragment, null);
    }
    const Term = ({ term }) => {
        const Label = () => {
            if (!props.asLink ||
                (props.single && props.single.id === term.id) ||
                (props.asList &&
                    typeof props.single === "undefined" &&
                    term.id === context.archivePage.id)) {
                return React.createElement("span", { className: classNames }, term.name);
            }
            return (React.createElement(Link, { to: term.uri, className: props.asList ? undefined : classNames, title: term.allCategories
                    ? "Afficher tous les articles"
                    : "Afficher les articles de la catégorie : " + term.name }, term.name));
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(Label, null),
            term.children && term.children.length ? (React.createElement("ul", { className: "is-style-list-no-disc" }, term.children.map((childTerm) => {
                return (React.createElement("li", { key: childTerm.id },
                    React.createElement(Term, { term: childTerm })));
            }))) : (React.createElement(React.Fragment, null))));
    };
    const allCategories = {
        allCategories: true,
        id: context.archivePage.id,
        name: "Les catégories d'actualités",
        uri: archivePageUri,
    };
    if (!props.asList) {
        return React.createElement(Term, { term: props.children[0] });
    }
    else {
        return (React.createElement("nav", { className: classNames },
            React.createElement("ul", { className: "is-style-list-no-disc" }, [allCategories, ...fixCategories([...props.children])].map((term) => {
                return (React.createElement("li", { key: term.id },
                    React.createElement(Term, { term: term })));
            }))));
    }
};
PostTerms._ges_name = "PostTerms";
export default PostTerms;
